module.exports = __webpack_public_path__ + "img/whiskas.5800ae09.png";